import { Link } from "react-router-dom";
import Button from "../elements/Button";
import styles from "./ui.module.scss";
//import history from "../utils/history";
import { useLocation } from "react-router-dom";

export function LoginButton(): JSX.Element {
  const { pathname, hash } = useLocation();
  const paramsStr = getPrevPathParamsStr(pathname, hash);

  return (
    <Link to={"/login" + paramsStr} className="margin-right">
      <Button color="grey" style={{ width: 118 }}>
        Login
      </Button>
    </Link>
  );
}

export function SignupButton(): JSX.Element {
  const { pathname, hash } = useLocation();
  const paramsStr = getPrevPathParamsStr(pathname, hash);

  return (
    <Link to={"/sign-up" + paramsStr} className={styles.signUp}>
      <Button color="lightGrey" style={{ width: 118 }}>
        Sign Up
      </Button>
    </Link>
  );
}

export function SignOutButton(): JSX.Element {
  const { pathname, hash } = useLocation();
  const paramsStr = getPrevPathParamsStr(pathname, hash);

  return (
    <div>
      <Link to={"/sign-out" + paramsStr}>
        <Button color="grey">Sign Out</Button>
      </Link>
    </div>
  );
}

export function getPrevPathParamsStr(pathname: string, hash: string): string {
  const prevPath =
    "?prevpath=" +
    pathname.replace("/", "") +
    "&prevhash=" +
    hash.replace("#", "");
  return prevPath.indexOf(".") === -1 ? prevPath : ""; // Basic sanitize
}
